import { Link } from 'react-router-dom';

const comparisonData = [
  { feature: 'Research Organization', hipobuy: 'High — Structured & Sortable', traditional: 'Low — Manual & Scattered' },
  { feature: 'Research Speed', hipobuy: 'Fast — Filter & Compare Instantly', traditional: 'Slow — Browse One by One' },
  { feature: 'Product Comparison', hipobuy: 'Easy — Side-by-Side View', traditional: 'Difficult — Tab Switching Required' },
  { feature: 'Beginner Friendly', hipobuy: 'Yes — Guided Layout', traditional: 'Medium — Steep Learning Curve' },
  { feature: 'Category Coverage', hipobuy: 'Extensive — 14+ Categories', traditional: 'Limited — Search Dependent' },
  { feature: 'Price Tracking', hipobuy: 'Built-in Overview', traditional: 'Manual Note-Taking' },
];

export default function ComparisonSection() {
  return (
    <section id="comparison" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            Hipobuy Spreadsheet vs Traditional Research
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            See why organized spreadsheet research outperforms manual browsing for product discovery
          </p>
        </div>

        <div className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b border-background-200">
                  <th className="text-left px-5 md:px-6 py-4 text-sm font-semibold text-foreground-800 whitespace-nowrap">
                    Feature
                  </th>
                  <th className="text-left px-5 md:px-6 py-4 text-sm font-semibold text-primary-700 whitespace-nowrap">
                    <i className="ri-sparkling-line mr-1.5"></i>
                    Hipobuy Spreadsheet
                  </th>
                  <th className="text-left px-5 md:px-6 py-4 text-sm font-semibold text-foreground-600 whitespace-nowrap">
                    <i className="ri-search-line mr-1.5"></i>
                    Normal Search
                  </th>
                </tr>
              </thead>
              <tbody>
                {comparisonData.map((row, index) => (
                  <tr
                    key={row.feature}
                    className={`border-b border-background-100 ${
                      index % 2 === 0 ? 'bg-background-50' : 'bg-background-100/50'
                    }`}
                  >
                    <td className="px-5 md:px-6 py-3.5 text-sm font-medium text-foreground-800 whitespace-nowrap">
                      {row.feature}
                    </td>
                    <td className="px-5 md:px-6 py-3.5 text-sm text-primary-700">
                      {row.hipobuy}
                    </td>
                    <td className="px-5 md:px-6 py-3.5 text-sm text-foreground-600">
                      {row.traditional}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div id="safety" className="mt-12 text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-accent-100 text-accent-800 mb-5">
            <i className="ri-shield-check-line text-lg"></i>
            <span className="text-sm font-semibold">Safety First</span>
          </div>
          <h3 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-4">
            Stay Safe While Shopping
          </h3>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto mb-6 leading-relaxed">
            Always verify seller credibility, check product reviews carefully, and use trusted platforms. Our <Link to="/hipobuy-spreadsheet-guide" className="text-primary-600 hover:text-primary-700 font-medium underline">Hipobuy Spreadsheet Guide</Link> includes a dedicated safety section with tips on identifying reliable sources and avoiding common shopping pitfalls.
          </p>
          <Link
            to="/hipobuy-spreadsheet-guide"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            Read Full Safety Guide
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}